document.addEventListener("turbolinks:load", function() {
})